import { Directive, ElementRef, Input, OnInit, OnDestroy, } from '@angular/core';
import { NgControl, FormControl, FormGroup, } from '@angular/forms';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/takeWhile';

import { LocalStorageService } from '../service/local-storage.service';

/**
 * 自動保存ディレクティブ.
 */
@Directive({
  selector: '[sunAutoSave]'
})
export class AutoSaveDirective implements OnInit, OnDestroy {

  /** Subscription. */
  private subscription: Subscription = new Subscription();

  /** FormGroup. */
  @Input() formGroup: FormGroup;

  /** sunAutoSaveの属性値. */
  @Input() sunAutoSave: string;

  /**
   * コンストラクタ.
   *
   * @param el ElementRef
   * @param localStorageService LocalStorageService
   */
  constructor(
    private el: ElementRef,
    private localStorageService: LocalStorageService
  ) { }

  /**
   * 初期処理.
   */
  ngOnInit(): void {
    // フォームグループのChangeイベントを監視し、ローカルストレージに保存する
    this.subscription.add(this.formGroup.statusChanges.takeWhile(() => true).subscribe(status => {

      // ローカルストレージの容量の関係上、ファイルの場合は除外する。
      // ファイルは、オブジェクト or オブジェクト配列になるので、それ以外を格納する。
      //   { fileName: file.name; mimeType: mimeType; data: data; };
      const target = this.formGroup.value;
      const obj = {};

      // 配列以外をコピー
      Object
        .keys(target)
        .filter(key => ['string', 'number', 'boolean'].includes(typeof target[key]))
        .forEach(key => obj[key] = target[key]);

      // オブジェクト配列以外をコピー
      Object
        .keys(target)
        .filter(key => Array.isArray(target[key]))
        .filter(key => (target[key]).length > 0 && ['string', 'number', 'boolean'].includes(typeof target[key][0]))
        .forEach(key => obj[key] = target[key]);

      this.localStorageService.save(this.sunAutoSave, obj);
    }));

    // ローカルストレージに値がある場合は、復元する
    const object: { [key: string]: string } = this.localStorageService.load(this.sunAutoSave);

    if (!object) {
      return;
    }
    this.formGroup.patchValue(object);
  }

  /**
   * 終了処理.
   */
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/common-app/directive/auto-save.directive.ts